import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

type EventDetails = {
  title: string;
  formatted_datetime: string;
  location_street: string;
  location_city: string;
  location_state: string;
};

type TableRow = (string | number | null)[];

export const exportEventPdf = ({
  docTitle,
  tableHeaders,
  tableData,
  eventDetails,
  filenamePrefix = "event-export",
}: {
  docTitle: string;
  tableHeaders: string[];
  tableData: TableRow[];
  eventDetails: EventDetails;
  filenamePrefix?: string;
}) => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text(docTitle, doc.internal.pageSize.getWidth() / 2, 15, {
    align: "center",
  });

  // Event Info
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  let y = 25;
  doc.text(eventDetails.title, doc.internal.pageSize.getWidth() / 2, y, {
    align: "center",
  });

  y += 7;
  doc.text(
    eventDetails.formatted_datetime,
    doc.internal.pageSize.getWidth() / 2,
    y,
    {
      align: "center",
    }
  );

  y += 7;
  const location = `${eventDetails.location_street}, ${eventDetails.location_city}, ${eventDetails.location_state}`;
  doc.text(location, doc.internal.pageSize.getWidth() / 2, y, {
    align: "center",
  });

  // Table
  const head = [tableHeaders];
  const body = tableData;

  autoTable(doc, {
    head,
    body,
    startY: y + 10,
    headStyles: {
      fontStyle: "bold",
    },
  });

  const safeTitle = eventDetails.title.replace(/\s+/g, "-").toLowerCase();
  doc.save(`${filenamePrefix}-${safeTitle}.pdf`);
};
